<template>
    <div
        class="c-preview"
    >
        <div class="c-progress">
            <div class="c-currency" :style="{
                color: textColor,
            }">
                <span
                    class="c-currency__total"
                >{{
                        toCurrency(amountProgress)
                    }}</span
                >
                of
                <span
                    class="c-currency__goal"
                >{{
                        toCurrency(goal)
                    }} goal</span
                >
            </div>
            <div :style="{
                    backgroundColor: progressColor,
                    borderRadius: borderRadius + 'px',
                    borderWidth: borderSize + 'px',
                    borderColor: progressColor,
                    borderStyle: 'solid',
            }">
                <b-progress
                    show-progress
                    animated
                    :max="100"
                    :style="{
                        backgroundColor: backgroundColor,
                        borderRadius: borderRadius + 'px',

                    }"
                    :class="{'position-relative': progress < 50}"
                >
                    <b-progress-bar
                        v-if="progress >= 50"
                        :value="progress"
                        :label="`${(
                            (progress / 100) *
                            100
                        ).toFixed(0)}%`"
                        :variant="progressColor"
                        :style="{
                            backgroundColor: progressColor,
                            color: percentageColor,

                        }"
                    ></b-progress-bar>
                    <b-progress-bar
                        v-else
                        :value="progress"
                        :label-html="`<span class='progress-bar-label-right'>${(
                            (progress / 100) *
                            100
                        ).toFixed(0)}%</span>`"
                        :variant="progressColor"
                        :style="{
                            backgroundColor: progressColor,
                            color: textColor,
                        }"
                    ></b-progress-bar>
                </b-progress>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PublicWidgetGoalMeter',
    props: {
        data: Object,
    },
    data() {
        return {
            name: '',
            campaign: '',
            htmlCode: '',
            backgroundColor: '#fff',
            textColor: '#212830',
            progressColor: '#2797FF',
            borderSize: 0,
            borderSizeMin: 0,
            borderSizeMax: 10,
            borderSizeStep: 1,
            borderRadius: 0,
            borderRadiusMin: 0,
            borderRadiusMax: 10,
            borderRadiusStep: 1,
            goal: 0,
            total: 0,
            amountTimer: null,
            amountProgress: 0,
            timer: null,
            progressStepper: 0,
            progress: 0,
            amount: 0,
            amountProgressStepper: 0,
        };
    },
    created() {
        this.loadData()
    },
    computed: {
        percentageColor() {
            return this.isHexColorDark(this.progressColor) ? '#fff' : '#000';
        },
    },
    methods: {
        loadData() {
            this.name = this.data.name;
            this.campaign = this.data.campaign_id;
            this.backgroundColor = this.data.background_color;
            this.textColor = this.data.text_color;
            this.progressColor = this.data.progress_color;
            this.borderSize = this.data.border_size;
            this.borderRadius = this.data.border_radius;

            this.goal = this.data.goal_amount;
            this.total = this.data.curr_amount;
            this.amount = Math.floor((this.total / this.goal) * 100);

            // stepper by 5 interval
            this.amountProgressStepper = Math.floor((this.goal / 100) * 3);
            this.progressStepper = Math.floor((this.amount / 100) * 10);

            this.amountTimer = setInterval(() => {
                const value = this.amountProgress + this.amountProgressStepper;
                if (value >= this.total) {
                    this.amountProgress = this.total;
                    clearInterval(this.amountTimer);
                    this.amountTimer = null;
                } else {
                    this.amountProgress = value;
                }
            }, 50);

            this.timer = setInterval(() => {
                const value = this.progress + this.progressStepper;
                if (value >= this.amount) {
                    this.progress = this.amount;
                    clearInterval(this.timer);
                    this.timer = null;
                } else {
                    this.progress = value;
                }
            }, 50);
        },
        isHexColorDark(color) {
            const hex = color.replace('#', '');
            const c_r = parseInt(hex.substr(0, 2), 16);
            const c_g = parseInt(hex.substr(2, 2), 16);
            const c_b = parseInt(hex.substr(4, 2), 16);
            const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
            return brightness < 128;
        },
        toCurrency(number) {
            return `$${new Intl.NumberFormat().format(number)}`;
        },
    },
    watch: {
        progress(val) {
            if (val >= this.amount) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        amountProgress(val) {
            if (val >= this.total) {
                clearInterval(this.amountTimer);
                this.amountTimer = null;
            }
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.amountTimer);
        this.timer = null;
        this.amountTimer = null;
    },
};
</script>

<style lang="scss" scoped>
.c-preview {
    padding: 16px;
    border-radius: 8px;
    width: 366px;
    height: 103px;
    aspect-ratio: 1;
    margin-bottom: 30px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .c-skeleton {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;

        &__item {
            background: #ddd;
            border-radius: 4px;
            height: 12px;

            &:nth-child(1) {
                width: 75%;
            }
            &:nth-child(2) {
                width: 80%;
            }
            &:nth-child(3) {
                width: 30%;
            }
            &:nth-child(4) {
                width: 100%;
            }
            &:nth-child(5) {
                width: 90%;
            }
        }
    }

    .c-progress {
        margin-block: 16px;
    }
    .c-currency {
        margin-bottom: 4px;
        text-align: center;
        &__goal {
            font-weight: 400;
            font-size: 18px;
        }
        &__total {
            font-weight: 700;
            font-size: 22px;
        }
    }
}
</style>
<style type="text/css">
.scroll-area .ps__rail-y { display: none !important; }
.progress-bar-label-right {
    position: absolute;
    right: 100px;
}
</style>
